// Schema and mapper for Salesforce Project_Page__c

export function fromSalesforceProjectPage(sfRecord) {
  const data = {
    info: {
      name: "",
      type: "",
      projectPageDescription: "",
      active: false,
      duplicateCheck: "",
      qualificationStepName: "",
      qualificationStep: "",
      projectId: "",
      projectName: "",
      projectObjectiveId: "",
      projectObjectiveName: "",
    },
    sys: {
      createdById: "",
      lastModifiedById: "",
    },
  };

  if (!sfRecord || typeof sfRecord !== "object") return { id: null, ...data };

  data.info.name = sfRecord?.Name || "";
  data.info.type = sfRecord?.Project_Page_Type__c || "";
  data.info.projectPageDescription =
    sfRecord?.Project_Page_Description__c || "";
  data.info.active = Boolean(sfRecord?.Active__c);
  data.info.duplicateCheck = sfRecord?.Duplicate_Check__c || "";
  data.info.projectId = sfRecord?.Project__c || "";
  data.info.projectObjectiveName =
    sfRecord.Project_Objective__r?.Name || sfRecord?.Project_Objective__c || "";
  data.info.projectObjectiveId =
    sfRecord?.Project_Objective__c || sfRecord.Project_Objective__r?.Id || "";
  data.info.projectName = sfRecord.Project__r?.Name || "";
  data.info.qualificationStep = sfRecord?.Project_Qualification_Step__c || "";
  data.info.qualificationStepName =
    sfRecord.Project_Qualification_Step__r?.Name || "";
  data.sys.createdById = sfRecord?.CreatedById || "";
  data.sys.lastModifiedById = sfRecord?.LastModifiedById || "";

  const id = sfRecord.Id || null;
  return { id, ...data };
}

// Map UI ProjectPage shape back to Salesforce fields for PATCH/UPDATE
export function toSalesforceProjectPage(uiRecord) {
  const record = {};
  if (!uiRecord || typeof uiRecord !== "object") return record;
  const info = uiRecord.info || {};
  if (uiRecord.id) record.Id = uiRecord.id;
  if (info.name !== undefined) record.Name = info.name || null;
  if (info.type !== undefined) record.Project_Page_Type__c = info.type || null;
  if (info.active !== undefined) record.Active__c = Boolean(info.active);
  if (info.projectPageDescription !== undefined)
    record.Project_Page_Description__c = info.projectPageDescription || "";
  if (info.duplicateCheck !== undefined)
    record.Duplicate_Check__c = info.duplicateCheck || null;
  if (info.projectId !== undefined) record.Project__c = info.projectId || null;
  if (info.qualificationStep !== undefined)
    record.Project_Qualification_Step__c = info.qualificationStep;
  if (info.projectObjectiveId !== undefined)
    record.Project_Objective__c = info.projectObjectiveId || null;
  return record;
}
